// removed by extract-text-webpack-plugin
module.exports = {"header":"src-layouts----index-module---header---2Yrp-","nav":"src-layouts----index-module---nav---3XZJc","navItem__link":"src-layouts----index-module---navItem__link---K9kqx"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/index.module.css
// module id = 320
// module chunks = 114276838955818